<app-selector
  #selector
  [multiple]="true"
  [type]="type"
  [(ngModel)]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [styles]="styles"
  [displayWithFn]="displayWithFn.bind(this)"
  [optionsFn]="optionsFn.bind(this)"
  [tooltip]="tooltip"
  newItemLabel="Create new VendorLot"
  (newItemClick)="on_create_new_lot()"

>
</app-selector>